
import { Vue, Component, Prop } from "vue-property-decorator";
import UiButton from "@/components/button/ui-button.vue";
import {
  Contractor,
  Maybe,
  Resource_Information_Card,
  Source,
  Tag,
  User,
} from "@/generated/graphql";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import ContractorResourceNotesModal from "@/components/common/ContractorResourceNotesModal.vue";
import EditResourceInformationModal from "@/components/common/EditResourceInformationModalNew.vue";
import AddResourceInformationModal from "@/components/common/AddResourceInformationNew.vue";
import MoreActions from "@/components/common/MoreActionsClick.vue";
import DELETE_RESOURCE_INFO from "@/apollo/contractors/DeleteResourceInformation.gql";

import UIButton from "@/components/button/ui-button.vue";
import ResourceCardPagination from "@/components/card/ResourceCardPagination.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import moment from "moment";
import S3Image from "@/components/common/s3-image.vue";
import GET_RESOURCE_INFO from "@/apollo/contractors/GetResourceInfo.gql";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";

@Component({
  components: {
    UiButton,
    MoreActions,
    ContractorResourceNotesModal,
    EditResourceInformationModal,
    AddResourceInformationModal,
    UIButton,
    ResourceCardPagination,
    UiButtonMessage,
    S3Image,
  },
  apollo: {
    resourceInfo: {
      query: GET_RESOURCE_INFO,
      variables() {
        return this.contractorId_;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount =
          data.resource_information_card.length;
        this.paginationConfig.limit = 5;
        return data.resource_information_card;
      },
    },
  },
})
export default class ResourceDataTable extends Vue {
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: Array, default: () => [] })
  readonly resourceCard!: Resource_Information_Card[];
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, default: "h-6 w-6" }) readonly avatarClasses!: string;
  @Prop({ type: Boolean, default: false }) readonly highlightAvatar!: boolean;
  @Prop({ type: String, default: undefined }) readonly image?: string;
  @Prop({ type: Boolean, default: false }) readonly primary!: boolean;
  @Prop({ type: String, default: undefined }) readonly initial?: string;
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: [String, Number], default: undefined }) readonly total!:
    | string
    | number
    | undefined;

  get avatarStyleClasses(): Record<string, boolean> {
    return {
      [this.avatarClasses]: Boolean(this.avatarClasses),
      ["border border-primary"]: this.highlightAvatar,
    };
  }

  get bgStyle(): object {
      return {
          background: hslColorFromName(this.initial || ""),
      };
  }
  paginationConfig: PaginationConfig = { ...paginationConfig };
  editdata: Resource_Information_Card[] = [];
  editnote: Resource_Information_Card[] = [];
  editrate: Resource_Information_Card[] = [];
  editprofilelink: Resource_Information_Card[] = [];
  editfromdate: Resource_Information_Card[] = [];
  edittodate: Resource_Information_Card[] = [];
  edittag: Resource_Information_Card[] = [];
  editsource: Source[] = [];
  editavailability: boolean = false;
  note: string = "";
  name: string = "";
  myLimit: number = 5;
  surname: string = "";
  avatar: string = "";
  created_at: string = "";
  _id: string = "";
  edit_id: string = "";

  tag: Tag[] = [];
  source: Source[] = [];
  user: User[] = [];

  resourceShown: boolean = false;
  editShown: boolean = false;
  processing: boolean = false;

  from_date: string = "";
  to_date: string = "";
  rate: string = "";
  notes: string = "";
  availability: boolean = false;
  profile_link: string = "";
  tag_id: string = "";
  source_id: string = "";
  showModal: boolean = false;
  modalShown: boolean = false;


  get sourceName(): string {
    //@ts-ignore
    return this.resourceCard.source;
  }
  //@ts-ignore
  getFormattedDate(date): string {
    return moment(date).format("DD MMMM YYYY");
  }

  get tagName(): Tag {
    //@ts-ignore
    return this.resourceCard!.tag?.name;
  }
  get getTagName(): Tag {
    //@ts-ignore
    // console
    return this.resourceCard[0].tag?.name;
  }

  showAddModal(): void {
    this.modalShown = true;
  }

  get contractorId_(): Object {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;
    return {
      offset: nextOffset,
      limit: this.myLimit,
      contractor_id: this.contractorId,
    };
  }

  get defaultImageClasses(): string {
    return "text-storm-gray text-sm font-medium rounded-full border border-gray-300 bg-white w-6 h-6 mr-1";
  }
  get defaultInitialsClasses(): string {
    return "inline-flex h-6 w-6 rounded-full items-center justify-center";
  }
   get getAvatrClass() {
    return "chipHeight flex-shrink-0 circleWidth rounded-full bg-primary-500 flex items-center text-xs justify-center text-white";
  }

  //@ts-ignore
  actionButton(data): void {
    this.note = data.notes;
    this.name = data.user?.given_name;
    this.surname = data.user?.family_name;
    this.avatar = data.user?.avatar;
    this.created_at = data.created_at;
    this.showModal = true;
  }

  editAction(data: Resource_Information_Card): void {
    this.editdata = data.id;
    //@ts-ignore
    this.editnote = data.notes;
    //@ts-ignore
    this.editrate = data.rate;
    //@ts-ignore
    this.editprofilelink = data.profile_link;
    this.editfromdate = data.from_date;
    this.edittodate = data.to_date;
    this.edittag = data.tag_id;
    //@ts-ignore
    this.editsource = data.source?.id;
    //@ts-ignore
    this.editavailability = data.availability;
    this.editShown = true;
  }

  addAction(): void {
    this.resourceShown = true;
  }

  closeModal(): void {
    this.showModal = false;
  }

  closeResource(): void {
    this.showModal = false;
    this.modalShown = false;
    // this.resourceShown = false;
  }

  closeEdit(): void {
    this.editShown = false;
  }
  //@ts-ignore
  removeNote(data): void {
    this.$confirm({
      title: `Delete Resource Info`,
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm: any) => {
        if (confirm) {
          this.deleteAction(data);
        }
      },
    });
  }

  deleteAction(data: {
    availability?: Maybe<boolean> | undefined;
    contractor?: Maybe<Contractor> | undefined;
    contractor_id?: any;
    from_date?: any;
    id: any;
    notes?: Maybe<string> | undefined;
    profile_link?: Maybe<string> | undefined;
    rate?: Maybe<number> | undefined;
    source?: Maybe<Source> | undefined;
    source_id?: any;
    tag?: Maybe<Tag> | undefined;
    tag_id?: any;
    to_date?: any;
    user_id?: any;
  }) {
    this._id = data.id;
    setTimeout(() => {
      this.refreshPage();
    }, 500);
    this.$eventBus.emit(
      NOTIFICATION,
      Message.successMessage("Source deleted successsfully")
    );
    return this.$apollo.mutate({
      mutation: DELETE_RESOURCE_INFO,
      variables: {
        id: this._id,
      },
    });
  }

  refreshPage(): void {
    this.$emit("refresh");
  }
}
